import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import back from "../Assets/Back.svg";
import { useLocation, useNavigate } from "react-router";
import { createSearchParams, useSearchParams } from "react-router-dom";
import styles from "./Profile.module.css";
import goviral from "../../assests/help/goviral.svg";
import goviralLogo23 from "../../assests/goviralLogo23.svg";
import hoeLogo from "../../assests/hoeLogo.png";
import instagram from "../../assests/help/instagram.svg";
import mail from "../../assests/help/mail.svg";
import serviceTicket from "../../assests/help/serviceTicket.svg";
import ErrorReportPopup from "../ErrorReportPopup/ErrorReportPopup";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";

const Help = ({ setSettings }) => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const { setReportErrorPopup, reportErrorPopup, buildType } =
    useContext(Context);
  const { currentUser } = useUserAuth();

  useEffect(() => {
    loadDetails();
  }, []);
  const loadDetails = async () => {
    try {
      let url = "";
      if (buildType == "highonevent") {
        url = "https://storage.googleapis.com/goviralcampaign/hoeHelp.json";
      } else {
        url = `${process.env.REACT_APP_HELP}.json`;
      }
      const data = await axios.get(url);
      setData(data.data);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const loadingFromApp = searchParams.get("from")?.startsWith("mobile");
  const location = useLocation();
  const openErrorReportPopup = () => {
    if (currentUser) {
      setReportErrorPopup(true);
    } else {
      navigate(
        {
          pathname: `/signup`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        {
          state: {
            previousLocation: location.pathname,
          },
        }
      );
    }
  };
  return (
    <div className="widthController ">
      <div className="flex flex-col text-[17px] px-[16px] bg-black pt-[30px] h-[100vh]">
        <div className="flex gap-[20px] items-center mb-[32px]">
          {!loadingFromApp && (
            <img
              src={back}
              alt=""
              onClick={() => {
                navigate(-1);
              }}
              className=" h-[50px] w-[13px]"
            />
          )}
          <span className="text-[21px] text-[#0F6ABE]">{data?.heading}</span>
        </div>
        <div>
          <img
            src={buildType == "highonevent" ? hoeLogo : goviralLogo23}
            className="mx-auto mb-[32px]"
          />
          <div className={styles.helpContainer}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="166.462px"
              height="161.438px"
              viewBox="0 0 342 292"
              fill="none"
              className={styles.rightSvg}
            >
              <g filter="url(#filter0_f_4833_201)">
                <ellipse
                  cx="318.71"
                  cy="-3.65529"
                  rx="83.2311"
                  ry="80.719"
                  transform="rotate(22.3992 318.71 -3.65529)"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_f_4833_201"
                  x="-2.14311"
                  y="-322.725"
                  width="641.706"
                  height="638.139"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="118.98"
                    result="effect1_foregroundBlur_4833_201"
                  />
                </filter>
              </defs>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="310"
              height="271"
              viewBox="0 0 310 271"
              fill="none"
              className={styles.leftSvg}
            >
              <g filter="url(#filter0_f_4833_200)">
                <ellipse
                  cx="34.591"
                  cy="250.622"
                  rx="61.591"
                  ry="36.6217"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_f_4833_200"
                  x="-240.07"
                  y="0.929993"
                  width="549.322"
                  height="499.383"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="106.535"
                    result="effect1_foregroundBlur_4833_200"
                  />
                </filter>
              </defs>
            </svg>
            <p>Please feel free to reach out!</p>
            {data?.contactInfo?.instagram && (
              <a
                className="flex items-center"
                href={data?.contactInfo?.instagram?.link}
                target="_blank"
              >
                <img src={instagram} />
                {data?.contactInfo?.instagram?.display}
              </a>
            )}
            {data?.contactInfo?.email && (
              <a
                className="flex items-center"
                href={`mailto:${data?.contactInfo?.email?.link}`}
                target="_blank"
              >
                <img src={mail} />
                {data?.contactInfo?.email?.display}
              </a>
            )}

            <a className="flex items-center" onClick={openErrorReportPopup}>
              <img src={serviceTicket} />
              Raise a support ticket
            </a>
          </div>
        </div>
        {/* <>
          <span className=" pb-[22px]">{data?.note}</span>
          {data?.helpVideo !== "" && (
            <video
              src={data?.helpVideo}
              className="w-[100%] h-[190px] left-0 pb-[35px]"
            ></video>
          )}
          <span className="pb-[20px]">{data?.subHeading}</span>
          <div className="flex flex-col text-[#787878]">
            <span className="pb-[10px]">{data?.contactInfo?.email}</span>
            <span className="pb-[10px]">
              {data?.contactInfo?.phoneAndWhatsApp}
            </span>
            {data?.contactInfo?.instagram && (
              <span className="pb-[10px]">{data?.contactInfo?.instagram}</span>
            )}
            {data?.contactInfo?.facebook && (
              <span className="pb-[10px]">{data?.contactInfo?.facebook}</span>
            )}
            {data?.contactInfo?.twitter && (
              <span className="pb-[10px]">{data?.contactInfo?.twitter}</span>
            )}
            {data?.contactInfo?.website && (
              <span className="pb-[10px]">{data?.contactInfo?.website}</span>
            )}
          </div>
        </> */}
      </div>
      {reportErrorPopup && <ErrorReportPopup setPopup={setReportErrorPopup} />}
    </div>
  );
};

export default Help;
